export default __webpack_public_path__ + "static/media/fog-hero.c0859305.png";